<div class="creditor-account-section" *ngFor="let account of accounts">
  <div class="container-fluid" [class.show-pointer]="canClick" (click)="handleClick(account)">
    <div class="account-familiar-name">{{pickName(account)}}</div>
    <div class="row account-line">
      <div class="account-name pull-left">{{account.CreditorName}}</div>
      <div class="account-invoice-balance pull-right">{{account.DefaultCurrencyCode}}&nbsp;{{account.Balance | number : '1.2-2'}}</div>
    </div>
    <div class="row account-line">
      <div class="account-Ref pull-left">Ref: {{account.CreditorAccountNo}}</div>
      <div class="account-number pull-right">{{account.BankAccountNumber}}&nbsp;&nbsp;{{account.SortCode | sortCode }}</div>
    </div>
  </div>
</div>




